'use strict';
import angular from 'angular';
import { UtilService } from './util.service';
export default angular.module('eeComUiApp.util', [])
    .factory('Util', UtilService)
    .name;
//# sourceMappingURL=util.module.js.map